import './DateRange.css';
import React from 'react';
import { get } from '../../../../../utils';
// ../../../../../resources/icons/IconChevronDown.svg
import { ReactComponent as IconChevronDown } from '../../../../../resources/icons/IconChevronDown.svg';
import { useHistory } from 'react-router-dom';
import Flatpickr from 'react-flatpickr';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import { Norwegian } from 'flatpickr/dist/l10n/no.js';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Romanian } from 'flatpickr/dist/l10n/ro.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
import { Turkish } from 'flatpickr/dist/l10n/tr.js';
import addQueryString, { removeQueryString } from '../../../../Listing/index';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../../utils/tealium';
const getFormatedDate = (date, lang) => {
  return new Date(date).toLocaleDateString(lang === 'en' ? 'en-GB' : lang, {
    // year: 'numeric',
    day: 'numeric',
    month: 'short'
  });
};
export const eventDatesRange = 'datesRange';
/*eslint-disable */

const DateRange = _ref => {
  let {
    fields,
    hideLabel,
    showButtonColor,
    pickDate,
    showLabel,
    fullWidth,
    resultsLabel,
    buttonYellow,
    buttonBlue,
    clearAllLabel,
    onChangeCallback,
    onToggleCallback,
    ignoreQueryString,
    clearWithCloseWrapper,
    setFilter,
    innerHeightAuto,
    widgetAnalytics,
    facetsName,
    wrapperToggle,
    setSubpanelLabel,
    clearAlllFilters,
    lang,
    analytics,
    clearAllCallback = () => {},
    setStartPage,
    submenuHelper = false,
    getFilterValue,
    primaryColor,
    columnsClass = 'col-md-12'
  } = _ref;
  const [dateFromFieldName, dateToFieldName] = facetsName;
  const [isOpen, setisOpen] = React.useState(false);
  const [date, setdate] = React.useState('');
  const [dateInit, setDateInit] = React.useState([]);
  const [formattedDate, setFormattedDate] = React.useState('');
  const [filterApplied, setfilterApplied] = React.useState(false);
  const [dateToDisable, setDateToDisable] = React.useState('');

  //const isOpen = false;
  const label = get(fields, 'title.jss.value');
  const type = get(fields, 'fieldTypeItem.item.fieldType.value') === 'Date' ? 'single' : 'range';
  // const clearAllLabel = 'clearAllLabel';
  let history = useHistory();
  const filterName = get(fields, 'name');
  const labelToId = (label || '').trim().replace(/\s+/g, '-').toLowerCase();
  const selectedPrimaryColor = primaryColor ? primaryColor : 'var(--main-color)';
  const variables = {
    "--date-range-primary-color": buttonYellow ? 'var(--events-widget-primary-color)' : selectedPrimaryColor
  };
  const fp = /*#__PURE__*/React.createRef();
  React.useEffect(() => {
    toggleFilter(!submenuHelper, false);
    getFilterValue && getFilterValue(fields.name, eventDatesRange, date);
    // if(!submenuHelper) {
    // 	submitFilters();
    // }
  }, [submenuHelper]);
  const toggleFilter = function (open) {
    let closePanel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    setisOpen(!open);
    wrapperToggle(open, closePanel);
    setSubpanelLabel(label);
    if (setStartPage) {
      setStartPage(true);
    }
  };
  const clearFilter = e => {
    setdate('');
    setDateInit([]);
    setDateToDisable('');
    setFormattedDate('');
    if (setStartPage) {
      setStartPage(isOpen);
    }
    if (fp && fp.current && fp.current.flatpickr) {
      fp.current.flatpickr.clear();
    }
    setisOpen(false);
    if (clearWithCloseWrapper) {
      wrapperToggle(true);
    }
    setfilterApplied(false);

    // if(clearAllCallback) {
    //   clearAllCallback()
    // }
    if (!ignoreQueryString) {
      removeQueryString(eventDatesRange, history);
    }
    setFilter('', 'daterange', '');
    getFilterValue && getFilterValue(fields.name, eventDatesRange, null);
    if (e) {
      e.stopPropagation();
    }
  };
  React.useEffect(() => {
    if (clearAlllFilters) {
      clearFilter();
    }
  }, [clearAlllFilters]);
  const submitFilters = e => {
    setisOpen(false);
    setfilterApplied(true);
    setFilter(date, 'daterange', dateInit);
    if (!ignoreQueryString) {
      addQueryString(eventDatesRange, date, history);
    }
    getFilterValue && getFilterValue(fields.name, eventDatesRange, date);
    if (e) {
      e.stopPropagation();
    }
  };
  const closeDropdwn = event => {
    if (event.target.closest) {
      if (!event.target.closest('.filter__field') && !event.target.closest('.filter__header')) {
        setisOpen(false);
      } else if (event.target.closest('.filter__header-links')) {
        setisOpen(false);
      }
    } else {
      setisOpen(false);
    }
  };
  React.useEffect(() => {
    document.body.addEventListener('click', closeDropdwn);
    return () => {
      if (!ignoreQueryString) {
        removeQueryString(eventDatesRange, history);
      }
    };
  }, []);
  const currentLocale = lang => {
    if (lang === 'ar') {
      return Arabic;
    }
    if (lang === 'ru') {
      return Russian;
    }
    if (lang === 'cs') {
      return Czech;
    }
    if (lang === 'nl') {
      return Dutch;
    }
    if (lang === 'fi') {
      return Finnish;
    }
    if (lang === 'de') {
      return German;
    }
    if (lang === 'ja') {
      return Japanese;
    }
    if (lang === 'no') {
      return Norwegian;
    }
    if (lang === 'pt') {
      return Portuguese;
    }
    if (lang === 'sv') {
      return Swedish;
    }
    if (lang === 'zh') {
      return Mandarin;
    }
    if (lang === 'da') {
      return Danish;
    }
    if (lang === 'fr') {
      return French;
    }
    if (lang === 'it') {
      return Italian;
    }
    if (lang === 'ko') {
      return Korean;
    }
    if (lang === 'pl') {
      return Polish;
    }
    if (lang === 'ro') {
      return Romanian;
    }
    if (lang === 'es') {
      return Spanish;
    }
    if (lang === 'uk') {
      return Ukrainian;
    }
    if (lang === 'tr') {
      return Turkish;
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    fullWidth: fullWidth,
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "selected-filter d-none"
  }, date), /*#__PURE__*/React.createElement("div", {
    className: "filter__field date-range",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    onClick: event => {
      onToggleCallback && onToggleCallback();
      if (setStartPage) {
        setStartPage(isOpen);
      }
      if (event.target.closest && !event.target.closest('.filter-panel__inner')) {
        toggleFilter(isOpen);
      }
      const classList = event.target.classList;
      let value;
      if (classList.contains('flatpickr-prev-month')) {
        value = 'Navigate Left';
      }
      if (classList.contains('flatpickr-next-month')) {
        value = 'Navigate Right';
      }
      !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterSelectDateAnalytics, analytics.params), value);
    },
    onKeyPress: event => {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        event.preventDefault();
        onToggleCallback && onToggleCallback();
        if (setStartPage) {
          setStartPage(isOpen);
        }
        if (event.target.closest && !event.target.closest('.filter-panel__inner')) {
          toggleFilter(isOpen);
        }
        const classList = event.target.classList;
        let value;
        if (classList.contains('flatpickr-prev-month')) {
          value = 'Navigate Left';
        }
        if (classList.contains('flatpickr-next-month')) {
          value = 'Navigate Right';
        }
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterSelectDateAnalytics, analytics.params), value);
      }
    },
    className: `filter-panel eloqua ${isOpen ? 'filter-panel--open' : ''}`
  }, hideLabel ? null : /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: `filter-panel__box ${isOpen ? 'filter-panel__box--openedDrop' : ''}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-panel__trigger js-filter-panel__trigger"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, formattedDate ? formattedDate : label), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: `filter-panel__inner ${innerHeightAuto ? 'filter-panel__inner-auto' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fp__inner-cb"
  }, /*#__PURE__*/React.createElement("button", {
    className: "body-medium fp__inner-clear btn--reset",
    onClick: e => {
      setFilter(`type:"Event"`, 'daterange', dateInit);
      !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
      clearFilter(e);
    },
    onKeyPress: e => {
      if (e.which === 13) {
        e.preventDefault();
        setFilter(`type:"Event"`, 'daterange', dateInit);
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
        clearFilter(e);
      }
    }
  }, clearAllLabel)), /*#__PURE__*/React.createElement(Flatpickr, {
    ref: fp,
    "aria-label": labelToId,
    options: {
      mode: type,
      minDate: dateToDisable || 'today',
      inline: true,
      locale: lang === 'en' ? 'en' : currentLocale(lang),
      nextArrow: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path fill="currentColor" d="M7.712 4a2.14 2.14 0 01-.284 2.927L4.996 9.045H19v1.913H4.996l2.432 2.116c.857.745.981 2.03.284 2.926L1 10l6.712-6z"/></svg>`,
      prevArrow: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path fill="currentColor" d="M7.712 4a2.14 2.14 0 01-.284 2.927L4.996 9.045H19v1.913H4.996l2.432 2.116c.857.745.981 2.03.284 2.926L1 10l6.712-6z"/></svg>`
    },
    onChange: (date, dateStr, instance) => {
      if (date && date.length !== 0) {
        onChangeCallback && onChangeCallback();
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${formatDate(date)}`);
        setDateInit(date);
        const date0Temp = new Date(date[0]);
        setDateToDisable(date0Temp);
        const userTimezoneOffset = date0Temp.getTimezoneOffset() * 60000;
        const date0 = new Date(date0Temp.getTime() - userTimezoneOffset).toString();
        if (date[1]) {
          const date1Temp = new Date(date[1]);
          const userTimezoneOffset1 = date1Temp.getTimezoneOffset() * 60000;
          var date1 = new Date(date1Temp.getTime() - userTimezoneOffset1).toString();
          setdate(`(${dateToFieldName} > ${Date.parse(date0) / 1000} AND ${dateFromFieldName} < ${Date.parse(date1) / 1000})`);
          setFormattedDate(`${[getFormatedDate(date[0], lang) + ' - ' + getFormatedDate(date[1], lang)]}`);
        } else {
          setdate(`(${dateToFieldName} > ${Date.parse(date0) / 1000 - 86400} AND ${dateFromFieldName} < ${Date.parse(date0) / 1000 + 86400})`);
          setFormattedDate(getFormatedDate(date[0], lang));
        }
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    style: showButtonColor ? {
      backgroundColor: showButtonColor
    } : {},
    onClick: e => {
      wrapperToggle(true);
      submitFilters(e);
      !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterShowResultsAnalytics, analytics.params));
    }
  }, pickDate ? pickDate : `${showLabel} ${resultsLabel}`))))));
};
function formatDate(dateArr) {
  const [date1, date2] = dateArr;
  const format = date => {
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    return (d <= 9 ? '0' + d : d) + '/' + (m <= 9 ? '0' + m : m) + '/' + y;
  };
  return `${format(date1)}${date2 ? ` - ${format(date2)}` : ''}`;
}
const StyledWrapper = _ref2 => {
  let {
    children,
    fullWidth,
    columnsClass
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${fullWidth ? '' : columnsClass}`
  }, children);
};
// export default DateRange;
export default DateRange;
export const commonStyles = "c1fnrthr";
/*eslint-disable */